export default __webpack_public_path__ + "static/media/onetap-draft.ad74ccb4.png";